<template>
  <div class="" :id="this.$route.name">
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">مدیریت محصولاتـ</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container">
          <div class="row">
            <div class="mb-3">
              <a v-if="AddProduct == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddProduct = 1" title="افزودن محصول جدید">
                <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
              </a>
              <a
                v-if="AddProduct != 0"
                class="d-inline float-right mx-2 mt-1"
                href="javascript:;"
                @click="
                  AddProduct = 0
                  Reload()
                "
                title="لغو افزودن"
              >
                <h4><i class="fas fa-times text-danger"></i></h4>
              </a>
            </div>
            <div class="col-12" v-if="AddProduct != 0">
              <div class="row" id="Product">
                <div class="col-md-3 col-12">
                  <div class="mt-2">
                    <small id="LblName">نام محصول</small>
                    <input type="text" class="form-control InputText required" v-model="Product.Name" />
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="mt-2">
                    <small id="LblAmount">قیمت محصول</small>
                    <input dir="ltr" type="text" @keypress="$ValidNumber($event, 15)" @keyup="Product.Amount = $PutCommatoInput_New($event)" class="form-control 3ragham" v-model="Product.Amount" />
                  </div>
                </div>
                <div class="col-md-2 col-12">
                  <div class="mt-2">
                    <small id="LblOnlineSell">فروش آنلاین</small>
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="OnlineSell" v-model="Product.OnlineSell" />
                        <label class="custom-control-label mr-2" for="OnlineSell"> </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="col-md-2 col-12">
                  <div class="mt-2">
                    <small id="LblIsLicense">نیاز به لایسنس</small>
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="IsLicense" v-model="Product.IsLicense" />
                        <label class="custom-control-label mr-2" for="IsLicense"> </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="col-md-2 col-12">
                  <div class="mt-2">
                    <small id="LblArchive">بایگانی</small>
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="isSmsactive" v-model="Product.Archive" />
                        <label class="custom-control-label" for="isSmsactive">بایگانی</label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="mt-2">
                    <small id="LblNamayeshDarGozaresh">نمایش در گزارش توسعه</small>
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="isNamayeshDarGozaresh" v-model="Product.NamayeshDarGozaresh" />
                        <label class="custom-control-label" for="isNamayeshDarGozaresh">نمایش</label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="mt-2">
                    <small id="LblNeedSubmit">نیاز به تمدید</small>
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="isNeedSubmit" v-model="Product.NeedSubmit" />
                        <label class="custom-control-label" for="isNeedSubmit">نیاز دارد</label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="mt-2">
                    <small id="LblName">نام دیتابیس</small>
                    <input type="text" class="form-control InputText required" v-model="Product.DbName" />
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <div class="mt-2">
                    <small id="LblName">نام Context</small>
                    <input type="text" class="form-control InputText required" v-model="Product.ContextName" />
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="mt-2">
                    <small id="LblName">نام مخفف محصول (با نوشتن یک کاما نام های مخفف را از هم جدا کنید) </small>
                    <input type="text" class="form-control InputText required" v-model="Product.MoxafafName" />
                  </div>
                </div>
                <div class="col-md-3 col-12"></div>
                <div class="col-md-3 col-12 mt-2">
                  <button v-if="AddProduct == 1" class="btn btn-success mt-4 text-center w-100" @click="SetProduct">ثبت محصول</button>
                  <button v-if="AddProduct == -1" class="btn btn-warning mt-4 text-center w-100" @click="EditProduct">ویرایش محصول</button>
                </div>
              </div>
            </div>
            <div class="col-12" v-else>
              <div class="row mt-2">
                <!-- <div class="col-md-3 col-12 mt-2" v-for="product in Products" :key="product.Id"> -->
                <!-- <CardBox>
                    <template v-slot:cardbox-icon1><i class="fad fa-box-alt mt-2"></i></template>
                    <template v-slot:b-dropdown-item>
                      <b-dropdown-item href="#" class="text-center" @click="OnEdit(product)">ویرایش</b-dropdown-item>
                      <b-dropdown-item href="#" class="text-center" @click="OnCatalog(product)">ثبت کاتالوگ</b-dropdown-item>
                    </template>
                    <template v-slot:cardbox-body>
                      <h6 class="card-title text-center">{{ product.Name }}</h6>
                      <h6 class="card-title text-center">قیمت محصول : {{ $Comma3ragham(product.Amount == null ? 0 : product.Amount) }}</h6>
                      <small v-if="product.OnlineSell == true" class="card-text text-success detail mt-4">محصول فروش آنلاین </small>
                      <small v-if="product.Archive == true" class="card-text text-danger detail mt-4">محصول بایگانی شده است</small>
                    </template>
                  </CardBox> -->

                <BnpGrid Selectable :Sortable="true" :action="true" :propsRows="Products" :propsColumn="propsColumn" :NoRowNum="true" v-if="$store.state.renderComponentGrid">
                  <template slot="action-slot" slot-scope="props">
                    <a href="#" class="mr-2 badge" data-title="ویرایش" @click="OnEdit(props.props)">
                      <h6><i class="fad fa-pen"></i></h6>
                    </a>
                    <a href="#" class="mr-2 badge" data-title="ثبت کاتالوگ" @click="OnCatalog(props.props)"
                      ><h6><i class="fad fa-receipt"></i></h6>
                    </a>
                  </template>
                  <template slot="Name" slot-scope="props">
                    <span :class="props.props.Archive == true ? 'text-danger' : ''">{{ props.props.Name }}</span>
                  </template>
                  <template slot="Amount" slot-scope="props">
                    {{ $Comma3ragham(props.props.Amount == null ? 0 : props.props.Amount) }}
                  </template>
                </BnpGrid>
                <!-- </div> -->
              </div>
              <!-- <Pagination :List="Products" :CountOfPage="8" @ListResult="ListResult" v-if="$store.state.RenderComponentCard"> </Pagination> -->
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import CardBox from '@/components/CardBox/CardBox'
import Pagination from '@/components/Pagination/Pagination'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  data() {
    return {
      AddProduct: 0,
      Product: {},
      Products: [],
      propsColumn: [
        { name: 'Name', label: 'نام', visibility: true },
        { name: 'Amount', label: 'قیمت محصول', visibility: true },
        { name: 'OnlineSell', label: 'فروش آنلاین', visibility: true },
        { name: 'Archive', label: 'بایگانی', visibility: true },
        { name: 'NeedSubmit', label: 'نیاز به تمدید', visibility: true },
      ],
    }
  },
  components: {
    Card,
    CardBox,
    Pagination,
    BnpGrid,
  },
  methods: {
    GetProducts() {
      this.$store.state.RenderComponentCard = false
      var DataAxios_GetProducts = { Action: 'Products', mehod: 'Get', ArryfildValue: null }
      this.$PostData(DataAxios_GetProducts).then((result) => {
        if ((result.status = 'success')) {
          this.$store.state.RenderComponentCard = true
          this.Products = result.Rrsult
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => (this.$store.state.renderComponentGrid = true))
        }
      })
    },
    ListResult(res) {
      this.Products = res
    },
    SetProduct() {
      this.Product.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
      var DataAxios_SetProducts = { Action: 'Products', Method: 'post', ArryfildValue: this.Product }
      this.$PostData(DataAxios_SetProducts).then((result) => {
        if ((result.status = 'success')) {
          this.Reload()
          this.GetProducts()
        }
      })
    },
    OnEdit(row) {
      this.$store.state.OldDataForLog = JSON.stringify(row)
      this.Product = row
      this.AddProduct = -1
    },
    Reload() {
      this.Product = {}
      this.AddProduct = 0
    },
    EditProduct() {
      this.Product.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.Product.TblUserGrpIdInsert = this.Product.TblUserGrpIdInsert
      var DataAxios_SetProducts = { Action: 'Products', Method: 'put', ArryfildValue: this.Product }
      this.$PostData(DataAxios_SetProducts).then((result) => {
        if ((result.status = 'success')) {
          this.$SetLog(DataAxios_SetProducts.ArryfildValue, 0, 0, 'Products', 'محصول')
          this.Reload()
          this.GetProducts()
        }
      })
    },
    OnCatalog(product) {
      this.$router.push({ name: 'Cataloge', params: { product: product, newCat: true } })
    },
  },
  created() {
    this.GetProducts()
  },
}
</script>
<style scoped></style>
